import React from "react";
import { StyledGrid } from "components/simple";
import { abstractionThemeColor, themeColor } from "style/constants";
import { ThemeKey } from "types";

interface Props {
  assessment?: string;
  theme: ThemeKey;
  size?: string;
  borderColor?: string;
}

const ThemeKeyIcon: React.FC<Props> = ({
  assessment,
  theme,
  size,
  borderColor = "transparent"
}: Props) => {
  const pairNumber = Math.ceil(theme.key / 2);

  const getLabel = () => {
    if (theme.title.includes("Abstract")) {
      return `A${pairNumber}`;
    } else if (theme.title.includes("Concrete")) {
      return `C${pairNumber}`;
    }
    return `T${theme.key}`;
  };

  const getThemeColor = () => {
    if (assessment === "Abstraction") {
      return abstractionThemeColor[theme.key];
    }
    return themeColor[theme.key];
  };

  return (
    <StyledGrid border={`2px solid ${borderColor}`} borderRadius="50%" padding="2px">
      <StyledGrid
        container
        borderRadius="50%"
        backgroundColor={getThemeColor()}
        width={size || "50px"}
        height={size || "50px"}
        justifyContent="center"
        alignContent="center"
      >
        <span>{getLabel()}</span>
      </StyledGrid>
    </StyledGrid>
  );
};

export default ThemeKeyIcon;
